import moment from "moment-jalali";
import { Button, Col, Form, Row } from "react-bootstrap";
import SearchableSelect from "../../../Components/SearchableSelect";
import { getUserListASync } from "../../../store/api/Users";
import { useState } from "react";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker2";
import { Reply } from "react-bootstrap-icons";
import { onDateChange } from "../../../store/api/CommonFunctions";
import { getStageUserAndStatusListAsync } from "../../../Office/store/api/FlowAPI";

export default function ModalNewRefer({ onDataChange, defaultReferDesc }) {
    const { control } = useForm();

    //#region functions
    const loadUserOptions = async (qry) => {
        const result = await getStageUserAndStatusListAsync(qry);
        if (Array.isArray(result?.Data?.UserList)) {
            return result.Data.UserList.map(r => ({
                value: r.ID,
                label: r.Name
            }));
        }
        return [];
    }
    const handleUserSelect = (opt) => {
        onDataChange({
            UserId: opt?.value,
            UserName: opt?.label
        });
    };
    const handleDeadline = (value) => {
        onDataChange({
            DeadlineDate: value.local("en").format("YYYY-MM-DD")
        })
    }
    const preventEnter = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
        }
    }
    //#endregion
    return (
        <Row className="mt-3">
            <Col md={2} className="form-group">
                <label>انتخاب کاربر:</label>
                <SearchableSelect
                    control={control}
                    name="UserId"
                    placeholder="انتخاب کاربر..."
                    loadOptions={loadUserOptions}
                    onChange={handleUserSelect}
                />
            </Col>
            <Col md={2} className="form-group">
                <label>سررسید:</label>
                <DatePicker isGregorian={false} timePicker={false} className="form-control" min={moment()} inputFormat="YYYY-MM-DD"
                    onChange={handleDeadline} />
            </Col>
            <Col className="form-group">
                <label>شرح ارجاع:</label>
                <input type="text" className='form-control' defaultValue={defaultReferDesc}
                    onKeyDown={preventEnter}
                    onChange={e => onDataChange({ReferDescription: e.target.value })} />
            </Col>
        </Row>
    )
}